export default function (...fns: ((value: unknown) => unknown)[]) {
    return (value: unknown) => fns.reduce((prev, fn) => fn(prev), value)
}
